import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { take } from 'rxjs';
import { QuickbooksStore } from '../quickbooks.store';

@Component({
  selector: 'app-qb-button',
  templateUrl: './qb-button.component.html',
  styleUrls: ['./qb-button.component.scss'],
  imports: [NgOptimizedImage],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QbButtonComponent {
  readonly store = inject(QuickbooksStore);

  @Input() height: number = 44;
  @Input() width: number = 251.24;

  qbConnect(): void {
    this.store
      .connect()
      .pipe(take(1))
      .subscribe((url: string) => {
        window.location.href = url;
      });
  }
}
